import React, { useEffect, lazy, useState, createContext } from "react";
// helpers for lazy reCAPTCHA handling
import { initRecaptcha, getRecaptchaToken } from "./recaptcha";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "react-snackbar-messages";

//import Constant from "./constants";
import PublicRoute from "./routes/PublicRoute";
import ProtectedRoute from "./routes/ProtectedRoute";
import AuthProvider from "./Providers/AuthProvider";
import "@govtechsg/sgds/css/sgds.css";
import "./css/theme.css";
import "./css/styles.css";
import "./Components/Common/CountryPhone/css/bootstrap.scss";
import Root from "./Pages/Root";
import NotFound from "./Pages/NotFound";
import IndexPage from "./Pages/IndexPage";
import Loader from "./Components/Loader";
import { axiosInstance } from "./Api";
import Slider from "./Components/Common/Carousel/Slider";

const Login = lazy(() => import("./Pages/Login/Login"));
const FormEditDetail = lazy(() => import("./Components/FormEditDetail"));
const Dashboard = lazy(() => import("./Pages/Dashboard"));
const ApplyPermit = lazy(() => import("./Pages/ApplyPermit"));
const ApplicationDetails = lazy(() => import("./Components/ApplicationDetails"));
const CheckPermitEligibility = lazy(() => import("./Components/PermitEligibilityChecker/CheckPermitEligibility"));
const UserProfile = lazy(() => import("./Pages/Profile/UserProfile"));
const UserStatus = lazy(() => import("./Pages/Profile/UserStatus"));




export const CommonDataContext = createContext(null);

const App = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [commonInItData, setCommonInItData] = useState(null);
  // const { checkNetwork } = require('./Components/Common/ErrorHandler');

  // const snackbar = useSnackbar();

  // const showSnackbar = (title, variant) => {
  //   snackbar.add(title, {
  //     appearance: variant,
  //     autoDismiss: true
  //   })
  // }

  //Commented 11062026 useEffect(() => {
  //   // start loading the grecaptcha script in background; UI does not wait for it
  //   initRecaptcha(Constant.SITE_KEY).catch((err) => {
  //     console.error("reCAPTCHA initialization failed", err);
  //   });

  //   async function initializeRecaptcha() {
  //     try {
  //       await initRecaptcha(Constant.SITE_KEY);
  //     } catch (error) {
  //       console.error("reCAPTCHA initialization failed", error);
  //     }
  //   }

  //   initializeRecaptcha();
  // }, []);

  async function loadCommonInItData() {
    if (commonInItData) {
      return;
    }

    // if (!checkNetwork((title, variant)=>showSnackbar(title, variant))) {
    // //if (!checkNetwork(()=>{})) {
    //   return;
    // }

    try {
      //setShowLoader(true);
      const recaptchaToken = await getRecaptchaToken();
      const url = "/application/common/init-data";
      const { data: response } = await axiosInstance(recaptchaToken).get(url);
      setCommonInItData(response);
    } catch (error) {
      console.log("Failed to load common data.", error);
      if (error?.message === "Network Error" || !error.response) {
        // network error during init: user will see message when they try to use the app
      }
    }
  }

  // load common data when route is not /home (so home can render quickly)
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.pathname === "/home") {
      // skip for initial home render; may run later if user navigates away
      return;
    }

    loadCommonInItData();
  }, []);



  return (
    <>
      <SnackbarProvider>
        <AuthProvider>
          <CommonDataContext.Provider value={{ commonInItData, setCommonInItData }}>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Routes>
                <Route path="/" element={<Root />} errorElement={<NotFound />}>
                  <Route index={true} element={<IndexPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/newUser" element={<UserProfile isNewUser={true} />} />
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute>
                        <UserProfile />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/home"
                    element={
                      <PublicRoute
                        titleMeta="Civil Aviation Authority of Singapore (CAAS)"
                        descriptionMeta="CAAS SkySAFE Internet Application"
                      >
                        <Slider />


                      </PublicRoute>
                    }
                  />
                  <Route
                    path="/apply/permit"
                    element={
                      <ProtectedRoute>
                        <ApplyPermit />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/application/details"
                    element={
                      <ProtectedRoute>
                        <ApplicationDetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/application/details/edit"
                    element={
                      <ProtectedRoute>
                        <FormEditDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/checkPermitEligibility"
                    element={
                      <PublicRoute
                        titleMeta="(CAAS) | Permit Eligibility Check"
                        descriptionMeta="Check if you need permit/clearance for your planned activity."
                      >
                        <CheckPermitEligibility />
                      </PublicRoute>
                    }
                  />
                  <Route path="/ErrorPage" element={<NotFound />} />
                  <Route path="/userStatus" element={<UserStatus />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </Router>
          </CommonDataContext.Provider>
        </AuthProvider>
      </SnackbarProvider>
      <Loader show={showLoader} onHide={() => setShowLoader(false)} />
    </>
  );
};

export default App;
